export default __webpack_public_path__ + "static/media/robot_portrait.241c0139.svg";